import ReactFlow, { Background, ReactFlowProvider } from "react-flow-renderer";
import { useTranslation } from "react-i18next";
import { Widget } from "datastake-daf/dist/components";
import Style from "./style";
import useDataChainOfCustoryWidget from "./hook";

export default function DataChainOfCustoryWidget({ data = {}, loading }) {
  const { t } = useTranslation();
  const { onLoad, elements } = useDataChainOfCustoryWidget({ data });

  return (
    <Widget
      loading={loading}
      title={t('Data Chain of Custody')}
      className="with-border-header flex-1 h-w-btn-header no-p-body"
    >
      <Style className="flex-1 flex flex-column">
        <ReactFlowProvider>
          <ReactFlow
            onLoad={onLoad}
            className="flex-1"
            draggable={false}
            elements={elements}
          // nodesDraggable={false}
          // nodesConnectable={false}
          // selectNodesOnDrag={false}
          >
            <Background />
          </ReactFlow>
        </ReactFlowProvider>
      </Style>
    </Widget>
  );
}
